import { render, staticRenderFns } from "./persistent-notification-base.vue?vue&type=template&id=5c6650b7&scoped=true&"
import script from "./persistent-notification-base.vue?vue&type=script&lang=ts&"
export * from "./persistent-notification-base.vue?vue&type=script&lang=ts&"
import style0 from "./persistent-notification-base.vue?vue&type=style&index=0&id=5c6650b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6650b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
